import React from 'react';
import { StepWizardChildProps } from 'react-step-wizard';
import styled from 'styled-components';

import {
  FlexRow,
  SvgIcon,
  BaseProps,
  ArrowWithTailIcon,
} from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';

import { ProgressLine } from '../progress-line/progress-line';
import { useTranslation } from 'react-i18next';

const BackBtnContainer = styled.div(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  cursor: 'pointer',
  margin: '20px 30px',
}));

const SpanWrapper = styled.span(() => ({
  marginLeft: '10px',
}));

export interface TransactionWizardNavigationProps
  extends BaseProps,
    Partial<StepWizardChildProps> {
  stepsNames: string[];
  /**
   * **initialNavigationStep** need to be passed if you want to start from step other than 1
   * Also, it overrides the currentStep prop, because it's not working properly.
   *
   * @ISSUE: https://github.com/jcmcneal/react-step-wizard/issues/67
   */
  initialNavigationStep?: number;
}

export const TransactionWizardNavigation = (
  props: TransactionWizardNavigationProps
) => {
  const {
    stepsNames,
    initialNavigationStep,
    isActive,
    totalSteps,
    firstStep,
    lastStep,
    nextStep,
    previousStep,
    goToStep,
    hashKey,
    currentStep = 1,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const stepsTotalCount = stepsNames.length;

  const stepIndex = initialNavigationStep
    ? initialNavigationStep + (currentStep - initialNavigationStep)
    : currentStep;

  const isFirstStep = stepIndex === initialNavigationStep || stepIndex === 1;
  const isLastStep = stepIndex === stepsTotalCount;
  const prevStepNumber = stepIndex - 1;

  const handleBackClick = () => {
    previousStep && previousStep();
  };

  return (
    <div {...restProps}>
      {!isFirstStep && !isLastStep && (
        <BackBtnContainer onClick={handleBackClick}>
          <FlexRow align={'center'}>
            <SvgIcon
              src={ArrowWithTailIcon}
              role={'img'}
              alt={'Arrow back icon'}
            />
            <BodyText scale={'sm'} size={1} variation={'blue'}>
              <SpanWrapper>
                {t('Back to step')} {prevStepNumber}
              </SpanWrapper>
            </BodyText>
          </FlexRow>
        </BackBtnContainer>
      )}

      {/*<ProgressLine steps={stepsNames} currentIdx={stepIndex} />*/}
    </div>
  );
};
